export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
            <div className="flex-1 w-full max-w-lg">
              <div className="relative rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20modern%20cozy%20home%20entertainment%20setup%20with%20a%20large%20flat%20screen%20TV%20displaying%20colorful%20variety%20show%20graphics%2C%20warm%20ambient%20living%20room%20lighting%2C%20comfortable%20sofa%2C%20plants%2C%20minimalist%20interior%20design%20with%20wooden%20accents%2C%20evening%20atmosphere%2C%20cinematic%20mood%2C%20high-quality%20product%20photography%2C%20warm%20orange%20and%20amber%20tones&width=600&height=450&seq=about-51movies&orientation=landscape"
                  alt="51影视平台介绍 - 综艺节目免费在线观看"
                  className="w-full h-auto object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                <div className="absolute bottom-4 left-4 right-4 flex items-center gap-3">
                  <span className="bg-accent-500 text-white text-xs font-bold px-3 py-1 rounded-full whitespace-nowrap">51影视</span>
                  <span className="text-white/80 text-xs">让追综更简单</span>
                </div>
              </div>
            </div>
            <div className="flex-1 w-full">
              <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-4 whitespace-nowrap">
                关于我们
              </span>
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-black text-foreground-950 mb-6" style={{ fontFamily: 'var(--font-heading)' }}>
                51影视 — 你的专属综艺追看平台
              </h2>
              <div className="space-y-4 text-foreground-600 text-sm md:text-base leading-relaxed">
                <p>
                  51影视网成立于 2020 年，是国内领先的综艺节目免费在线观看平台。我们致力于为广大综艺爱好者提供最新、最全、最高清的综艺内容，让每一位用户都能享受到极致的追综体验。
                </p>
                <p>
                  平台汇聚了《奔跑吧》《极限挑战》《乘风2024》《王牌对王牌》《向往的生活》《脱口秀大会》《这就是街舞》《密室大逃脱》《心动的信号》《天赐的声音》等全网热门综艺，涵盖户外竞技、音乐竞演、喜剧脱口秀、悬疑推理、恋爱观察等多元品类。
                </p>
                <p>
                  我们坚持"免费、高清、不缓冲"的服务理念，采用行业领先的智能 CDN 加速与自适应码率技术，确保无论你身处何地，都能流畅观看 1080P 蓝光级画质内容。
                </p>
              </div>
              <div className="flex flex-wrap gap-6 mt-8">
                <div className="flex items-center gap-2">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                    <i className="ri-shield-check-line text-lg"></i>
                  </div>
                  <div>
                    <div className="text-sm font-bold text-foreground-900">安全可靠</div>
                    <div className="text-xs text-foreground-500">HTTPS 加密传输</div>
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                    <i className="ri-refresh-line text-lg"></i>
                  </div>
                  <div>
                    <div className="text-sm font-bold text-foreground-900">每日更新</div>
                    <div className="text-xs text-foreground-500">同步卫视播出</div>
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600">
                    <i className="ri-user-heart-line text-lg"></i>
                  </div>
                  <div>
                    <div className="text-sm font-bold text-foreground-900">千万用户</div>
                    <div className="text-xs text-foreground-500">共同的选择</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}